<template>
	<div v-if="isUserAllowedInLevel5or6">
		<BaseHeader :title="$t('rental_car_return').toString()"> </BaseHeader>
		<div class="px-8 mt-8 text-left">
			<div v-if="rentalCarContracts && rentalCarContracts.length === 0">
				<span class="text-red-500">{{ $t('attention_caps') }} </span>{{ $t('no_rented_cars', { company: evaluateArticle }) }}
			</div>
			<div v-else-if="rentalCarContracts && rentalCarContracts.length">
				<RentalCarContractReturnList :rental-car-contract-list="rentalCarContracts"></RentalCarContractReturnList>
			</div>
			<div v-else>
				<LoadingSpinner />
			</div>
		</div>
	</div>
	<Forbidden v-else />
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import RentalCarContractReturnList from '@/components/rentalcarcontract/pages/RentalCarContractReturnList';
import { RentalCarContractApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import RouteWatcher from '@/mixins/RouteWatcher';
import LoadingSpinner from '@/components/navigation/LoadingSpinner';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';

export default {
	name: 'RentalCarContractReturn',
	components: { Forbidden, LoadingSpinner, RentalCarContractReturnList, BaseHeader },
	mixins: [RouteWatcher, Authentication],
	data() {
		return {
			rentalCarContracts: undefined,
		};
	},
	computed: {
		evaluateArticle() {
			switch (this.$store.getters.repairShopLabel) {
				case 'Reparaturbetrieb':
					return 'den Reparaturbetrieb';
				case 'Autohaus':
					return 'das Autohaus';
				default:
					return 'das/den';
			}
		},
	},
	methods: {
		onRouteChange() {
			this.getOpenRentalContracts();
		},
		getOpenRentalContracts: function() {
			RentalCarContractApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.rentalcarcontractGet()
				.then(result => {
					this.rentalCarContracts = result.data;
				})
				.catch(error => {
					this.$swal(this.$t('general.error').toString(), this.$t('rental_car_contract_error').toString(), 'error');
				});
		},
	},
};
</script>

<style scoped></style>
